/*eslint-disable */
import React from 'react';
import { useClipboard } from 'core/hooks';

const ClipboardLabel = ({ children, className }) => {
  const { copy } = useClipboard();

  const handleCopy = () => {
    if (typeof children !== 'string') {
      throw new Error('ClipboardLabel only accept string type child');
    }

    copy(children);
  };

  return (
    <label className={`gx-pointer ${className}`} onClick={handleCopy}>
      {children}
    </label>
  );
};

export default ClipboardLabel;
